import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyTeamActivityLog = lazyWithRetry(() => import("./TeamActivityLog"));

const TeamActivityLog = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyTeamActivityLog {...props} />;

export default TeamActivityLog;
